import { render, staticRenderFns } from "./SortIcons.vue?vue&type=template&id=3f4e41cb&scoped=true&"
import script from "./SortIcons.vue?vue&type=script&lang=js&"
export * from "./SortIcons.vue?vue&type=script&lang=js&"
import style0 from "./SortIcons.vue?vue&type=style&index=0&id=3f4e41cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e41cb",
  null
  
)

export default component.exports